<template>
  <el-select 
    v-model="val" 
    class="AGlassColorSelector inline" 
    placeholder="색상"
    size="mini"
    @change="change">
    <el-option 
      v-for="item in items" 
      :key="item.id" 
      :label="item.name" 
      :value="item.id" 
    />
  </el-select>
</template>
<script>
import { mapGetters } from "vuex";
import { selector } from "@/common/mixins/selector";

export default {
  name: "AGlassColorSelector",
  mixins: [selector],  
  props: {
    product_id: {
      type: Number,
    },
  },  
  computed: {
    ...mapGetters(["table_product_glass_price", "table_glass_color"]),
    items: function() {
      let items = [];
      if (!this.product_id) {
        return items;
      }
      let colors = this.table_product_glass_price
        .filter(p => p.product_id === this.product_id)
        .map(p => p.glass_color_id);        
      if (colors.length < 1) {
        return items;
      }
      items = this.table_glass_color.filter(c=> colors.includes(c.id));
      return items;
    }
  },  
};
</script>
